const SCOPE = 'summaryContainer';
export default SCOPE;
